import { render, staticRenderFns } from "./Slip.vue?vue&type=template&id=1a9df7ec&"
import script from "./Slip.vue?vue&type=script&lang=js&"
export * from "./Slip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports